import styled from "styled-components";

export const SRegisterForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  height: 100%;
  max-width: 376px;
  min-width: 376px;
  margin-left: auto;
  margin-right: auto;
  margin-top: -64px;
`;
